var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var defaultConfig = { endpoint: 'ec-sf' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance.updateDefaults({ src: 10 });
        this.bi = biLoggerClientFactoryInstance.logger({});
    }
    Logger.prototype.productAddedToCartSf = function (params) {
        return this.bi.log(__assign({ evid: 1052, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnProductBoxSf = function (params) {
        return this.bi.log(__assign({ evid: 11, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.cartCreatedSf = function (params) {
        return this.bi.log(__assign({ evid: 1101, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnApplyPromotionalCodeSf = function (params) {
        return this.bi.log(__assign({ evid: 111, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.couponAppliedSfSrc10Evid112 = function (params) {
        return this.bi.log(__assign({ evid: 112, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnCheckoutWithEWalletSf = function (params) {
        return this.bi.log(__assign({ evid: 113, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 114, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.removedProductFromCartSf = function (params) {
        return this.bi.log(__assign({ evid: 115, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.updatedCartItemQuantitySf = function (params) {
        return this.bi.log(__assign({ evid: 116, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.errorWhenApplyingACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 117, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.removeACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 118, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.applyACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 119, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickedOnProductQuickViewSf = function (params) {
        return this.bi.log(__assign({ evid: 12, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.cartClickOnContinueShoppingSf = function (params) {
        return this.bi.log(__assign({ evid: 120, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnAddNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 121, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.saveNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 122, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.deleteNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 123, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 124, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.updateClickedInSelectYourShippingDestinationPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 125, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.cancelClickedInSelectYourShippingDestinationPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 126, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewOrderHistoryPageSf = function (params) {
        return this.bi.log(__assign({ evid: 127, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewOrderDetailsPageSf = function (params) {
        return this.bi.log(__assign({ evid: 128, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickInOrderHistoryPageSf = function (params) {
        return this.bi.log(__assign({ evid: 129, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.sortGallerySf = function (params) {
        return this.bi.log(__assign({ evid: 13, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToViewCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 130, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.galleryClickSortBy = function (params) {
        return this.bi.log(__assign({ evid: 139, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickLoadMoreInGallerySf = function (params) {
        return this.bi.log(__assign({ evid: 14, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.galleryClickFilter = function (params) {
        return this.bi.log(__assign({ evid: 140, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.galleryClickApplyFilter = function (params) {
        return this.bi.log(__assign({ evid: 141, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.galleryClickClearAllFilters = function (params) {
        return this.bi.log(__assign({ evid: 142, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToChangeGalleryFiltersSf = function (params) {
        return this.bi.log(__assign({ evid: 147, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.chooseLogicForSliderGalleryOnComponentSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 148, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.productGalleryResizeSf = function (params) {
        return this.bi.log(__assign({ evid: 15, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnBackToPaypalSf = function (params) {
        return this.bi.log(__assign({ evid: 160, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.shippingAddressSetSf = function (params) {
        return this.bi.log(__assign({ evid: 161, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnContinueToPaymentSf = function (params) {
        return this.bi.log(__assign({ evid: 163, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showMerchantPaymentPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 164, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showMerchantUpgradePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 165, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickNoThanksOnMerchantUpgradePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 166, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.placeOrderSf = function (params) {
        return this.bi.log(__assign({ evid: 168, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnCallToActionInMerchantPopUpSf = function (params) {
        return this.bi.log(__assign({ evid: 169, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewStorePageSf = function (params) {
        return this.bi.log(__assign({ evid: 17, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnBackInCheckoutProcessSf = function (params) {
        return this.bi.log(__assign({ evid: 170, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnEditCartSf = function (params) {
        return this.bi.log(__assign({ evid: 171, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showShippingPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 173, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.thankYouPageLoadSf = function (params) {
        return this.bi.log(__assign({ evid: 174, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.thankYouPageDownloadFileClickedSf = function (params) {
        return this.bi.log(__assign({ evid: 175, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.thankYouPageContinueShoppingClickedSf = function (params) {
        return this.bi.log(__assign({ evid: 176, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.paymentDetailsCompletedSf = function (params) {
        return this.bi.log(__assign({ evid: 177, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewStorePageInEditor = function (params) {
        return this.bi.log(__assign({ evid: 18, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.errorInAddProductToCartOneAppStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 183, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.oneAppStoreFrontClearCartSf = function (params) {
        return this.bi.log(__assign({ evid: 184, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickManageProductInCartOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 185, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnViewItemsInReviewOrderScreenOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 186, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnMyOrdersInThankYouPageOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 187, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickTrackOrderInMyOrderOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 188, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.storeFrontPopupShownClckedOa = function (params) {
        return this.bi.log(__assign({ evid: 189, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnChangeLinkInSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 196, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.linkChangedInSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 197, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.selectPaymentCategorySfCashier = function (params) {
        return this.bi.log(__assign({ evid: 200, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.cartWidgetLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 211, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.selectShippingMethodFromTheDropdownInCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 222, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnShippingDestinationInCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 223, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewEWalletModalSf = function (params) {
        return this.bi.log(__assign({ evid: 224, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickContinueEWalletModalSf = function (params) {
        return this.bi.log(__assign({ evid: 225, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.oaSfClickOnProductSocialShare = function (params) {
        return this.bi.log(__assign({ evid: 226, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnRelatedProductOa = function (params) {
        return this.bi.log(__assign({ evid: 229, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnImageOfProductOa = function (params) {
        return this.bi.log(__assign({ evid: 232, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.highRpuFeatureAdAssetShown = function (params) {
        return this.bi.log(__assign({ evid: 236, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.highRpuDismissFeatureAdAsset = function (params) {
        return this.bi.log(__assign({ evid: 237, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.imageGalleryOpenedInProductOa = function (params) {
        return this.bi.log(__assign({ evid: 238, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.errorInCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 24, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickAddToCartWithOptionsSf = function (params) {
        return this.bi.log(__assign({ evid: 248, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickAddToWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 260, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickRemoveFromWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 261, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToViewWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 265, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickLinkInMembersWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 266, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.productAddedToWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 267, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.productRemovedFromWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 268, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickInWarningScreenOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 270, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewCheckoutInLiveSitePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 273, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.notAcceptPaymentsVisitorPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 283, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.productOptionsDeleteOptionFromCatalog = function (params) {
        return this.bi.log(__assign({ evid: 32, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnLeftBarTabsOnComponentSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 33, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnSettingsTopBarDesignTab = function (params) {
        return this.bi.log(__assign({ evid: 34, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnCustomizeButtonInTheSettingsMenu = function (params) {
        return this.bi.log(__assign({ evid: 35, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.checkoutPageLoadSf = function (params) {
        return this.bi.log(__assign({ evid: 36, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.checkoutPageSpecificStageExpandedSf = function (params) {
        return this.bi.log(__assign({ evid: 37, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.exposureEventForTests = function (params) {
        return this.bi.log(__assign({ evid: 45, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.subscriptionsAreComingSoonVisitorPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 457, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.relatedProductsTestExposureProductPageLoad = function (params) {
        return this.bi.log(__assign({ evid: 47, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.chooseAPageToDisplayThisCollectionOnClicked = function (params) {
        return this.bi.log(__assign({ evid: 471, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.membersAddressInCheckoutWasChanged = function (params) {
        return this.bi.log(__assign({ evid: 48, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnProductOptionSf = function (params) {
        return this.bi.log(__assign({ evid: 486, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnCartIconToOpenMiniCartSf = function (params) {
        return this.bi.log(__assign({ evid: 49, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToOpenZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 490, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 491, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.zoomModalIsClosedSf = function (params) {
        return this.bi.log(__assign({ evid: 492, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.pictureNavigationInZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 493, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewMiniCart = function (params) {
        return this.bi.log(__assign({ evid: 50, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickInFilterScreenOa = function (params) {
        return this.bi.log(__assign({ evid: 500, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnFilterOa = function (params) {
        return this.bi.log(__assign({ evid: 506, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.giftCardCheckoutClickOnCheckbox = function (params) {
        return this.bi.log(__assign({ evid: 527, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.giftCardCheckoutClickApply = function (params) {
        return this.bi.log(__assign({ evid: 529, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnRightBarTabsWithinComponentSfe = function (params) {
        return this.bi.log(__assign({ evid: 53, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.currencyConverterClickAddCurrencySfe = function (params) {
        return this.bi.log(__assign({ evid: 530, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.currencyConverterClickGeneralInfoSfe = function (params) {
        return this.bi.log(__assign({ evid: 531, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.currencyConverterClickAddCurrenciesListSfe = function (params) {
        return this.bi.log(__assign({ evid: 532, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.currencyConverterClickDeleteCurrencySfe = function (params) {
        return this.bi.log(__assign({ evid: 533, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.currencyConverterChooseSiteCurrencyDisplay = function (params) {
        return this.bi.log(__assign({ evid: 534, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.giftCardCheckoutCodeApplied = function (params) {
        return this.bi.log(__assign({ evid: 535, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.giftCardCheckoutRemoveCode = function (params) {
        return this.bi.log(__assign({ evid: 536, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewProductPageSf = function (params) {
        return this.bi.log(__assign({ evid: 541, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewGallerySf = function (params) {
        return this.bi.log(__assign({ evid: 542, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewQuickViewSf = function (params) {
        return this.bi.log(__assign({ evid: 543, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.productWidgetLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 544, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.addToCartButtonLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 545, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.cartIconLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 546, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnPriceBreakdownWidgetInPpSf = function (params) {
        return this.bi.log(__assign({ evid: 550, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.priceBreakdownModalOpenSf = function (params) {
        return this.bi.log(__assign({ evid: 551, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickPlaceOrderWithSubscription = function (params) {
        return this.bi.log(__assign({ evid: 58, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewAddCollectionToSiteModalEditor = function (params) {
        return this.bi.log(__assign({ evid: 581, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.oaSfCustomizeProductGallery = function (params) {
        return this.bi.log(__assign({ evid: 595, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewShippingInfoModalSf = function (params) {
        return this.bi.log(__assign({ evid: 596, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickShippingInfoLinkSf = function (params) {
        return this.bi.log(__assign({ evid: 597, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickLogoutInCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 601, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.logoutModalInCheckoutLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 602, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.logoutModalInCheckoutClosedSf = function (params) {
        return this.bi.log(__assign({ evid: 603, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnProductDetailsSf = function (params) {
        return this.bi.log(__assign({ evid: 61, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.socialButtons = function (params) {
        return this.bi.log(__assign({ evid: 62, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnAddToCartSf = function (params) {
        return this.bi.log(__assign({ evid: 63, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToViewProductVelo = function (params) {
        return this.bi.log(__assign({ evid: 640, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnProductQuickViewVelo = function (params) {
        return this.bi.log(__assign({ evid: 641, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewVeloGallery = function (params) {
        return this.bi.log(__assign({ evid: 642, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.minimumOrderMessageIsShownInCart = function (params) {
        return this.bi.log(__assign({ evid: 653, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.minimumOrderModalIsShownInCheckout = function (params) {
        return this.bi.log(__assign({ evid: 654, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.minimumOrderClickOnGotItInErrorModalInCheckout = function (params) {
        return this.bi.log(__assign({ evid: 655, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnFilterInStoresOa = function (params) {
        return this.bi.log(__assign({ evid: 69, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.duplicateCollectionClickedSm = function (params) {
        return this.bi.log(__assign({ evid: 804, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showHideCategoriesClickedInModal = function (params) {
        return this.bi.log(__assign({ evid: 806, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.editCategoryListSidebar = function (params) {
        return this.bi.log(__assign({ evid: 809, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewStoresPanelInEditor = function (params) {
        return this.bi.log(__assign({ evid: 810, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.openAppSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 811, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeStyleColorSfe = function (params) {
        return this.bi.log(__assign({ evid: 812, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeGalleryCollectionSfe = function (params) {
        return this.bi.log(__assign({ evid: 813, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToReOrderProductsInCollectionSfe = function (params) {
        return this.bi.log(__assign({ evid: 814, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeImageRatioInGallerySfe = function (params) {
        return this.bi.log(__assign({ evid: 815, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeGalleryLayoutSfe = function (params) {
        return this.bi.log(__assign({ evid: 816, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.resetAppSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 819, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeCartIconSfe = function (params) {
        return this.bi.log(__assign({ evid: 820, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showHideCategoryListSidebar = function (params) {
        return this.bi.log(__assign({ evid: 821, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeMiniCartBehaviorSfe = function (params) {
        return this.bi.log(__assign({ evid: 822, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.categoryPageHeroSectionReadMoreClicked = function (params) {
        return this.bi.log(__assign({ evid: 823, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeProductPageLayoutSfe = function (params) {
        return this.bi.log(__assign({ evid: 824, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeProductPageDisplayedComponentsSfe = function (params) {
        return this.bi.log(__assign({ evid: 825, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeProductInWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 826, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnEditProductsInProductWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 827, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeHoverTypeSfe = function (params) {
        return this.bi.log(__assign({ evid: 828, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeWidgetButtonActionSfe = function (params) {
        return this.bi.log(__assign({ evid: 829, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnEditElementSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 830, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeElementSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 831, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.categoryPageBreadcrumbClicked = function (params) {
        return this.bi.log(__assign({ evid: 832, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeTextFieldSfe = function (params) {
        return this.bi.log(__assign({ evid: 833, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.categoryPageCategoryTreeClicked = function (params) {
        return this.bi.log(__assign({ evid: 834, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.showHideFiltersSortingSfe = function (params) {
        return this.bi.log(__assign({ evid: 835, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeSortingParameterSfe = function (params) {
        return this.bi.log(__assign({ evid: 836, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToOpenProductsListToChangeProductInWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 837, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.changeFilterOptionsParameterSfe = function (params) {
        return this.bi.log(__assign({ evid: 838, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.addCustomFilterSfe = function (params) {
        return this.bi.log(__assign({ evid: 839, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.removeCustomFilterSfe = function (params) {
        return this.bi.log(__assign({ evid: 840, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToAddWishlistSfe = function (params) {
        return this.bi.log(__assign({ evid: 841, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToRemoveWishlistSfe = function (params) {
        return this.bi.log(__assign({ evid: 842, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickToPreviewWishlistInMembersSfe = function (params) {
        return this.bi.log(__assign({ evid: 843, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.wishlistInstallationStage = function (params) {
        return this.bi.log(__assign({ evid: 844, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnProPlanUpgradeInComponentSetting = function (params) {
        return this.bi.log(__assign({ evid: 845, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.proPlanUpgradeModalLoaded = function (params) {
        return this.bi.log(__assign({ evid: 846, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnUpgradeButtonInProPlanModal = function (params) {
        return this.bi.log(__assign({ evid: 847, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.pagesAtAppInstallation = function (params) {
        return this.bi.log(__assign({ evid: 849, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnQuickActionStoresPanelInEditor = function (params) {
        return this.bi.log(__assign({ evid: 850, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnFreeText = function (params) {
        return this.bi.log(__assign({ evid: 851, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnQuantity = function (params) {
        return this.bi.log(__assign({ evid: 852, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnSubscriptionOption = function (params) {
        return this.bi.log(__assign({ evid: 853, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnMorePaymentOptions = function (params) {
        return this.bi.log(__assign({ evid: 854, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnAdditionalPictures = function (params) {
        return this.bi.log(__assign({ evid: 855, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnNavigation = function (params) {
        return this.bi.log(__assign({ evid: 856, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.errorMessageSf = function (params) {
        return this.bi.log(__assign({ evid: 857, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.categoryPageHeroSectionReadLessClicked = function (params) {
        return this.bi.log(__assign({ evid: 858, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.manageCategoryListSidebar = function (params) {
        return this.bi.log(__assign({ evid: 860, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.pageLoadingTimeSf = function (params) {
        return this.bi.log(__assign({ evid: 861, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnAddToCartBuyNow = function (params) {
        return this.bi.log(__assign({ evid: 863, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.viewProductPageVelo = function (params) {
        return this.bi.log(__assign({ evid: 864, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clientCallingSetupForGettingExperiments = function (params) {
        return this.bi.log(__assign({ evid: 888, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.newClickOnItemInShopPagesSettingSf = function (params) {
        return this.bi.log(__assign({ evid: 895, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickOnSwitchToCategoriesModalSf = function (params) {
        return this.bi.log(__assign({ evid: 896, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickSwitchToCategoriesVerificationModalSf = function (params) {
        return this.bi.log(__assign({ evid: 897, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.clickSwitchToCategoriesConfirmationModalSf = function (params) {
        return this.bi.log(__assign({ evid: 898, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    Logger.prototype.manuallyOptInToCategoriesSf = function (params) {
        return this.bi.log(__assign({ evid: 899, src: 10 }, params), { endpoint: 'ec-sf' });
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 10,
        endpoint: 'ec-sf'
    };
}
//# sourceMappingURL=index.js.map